// extracted by mini-css-extract-plugin
export default {"content":"Features_content__F+wBH"};